import { type UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { GetProductTypeListResponseDto } from "../../dtos/get-product-type-list-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetProductTypeListQueryParams = {
  options?: UseQueryOptions<GetProductTypeListResponseDto>;
};

export const useGetProductTypeListQuery = ({
  options
}: UseGetProductTypeListQueryParams = {}) => {
  return useQuery({
    queryKey: ProductQueryKeys.getProductTypeList().queryKey,
    queryFn: async () => await ProductService.getProductTypeList(),
    ...options
  });
};
